import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
  CCreateElement,
  CSidebar,
  CSidebarBrand,
  CSidebarNav,
  CSidebarNavDivider,
  CSidebarNavTitle,
  CSidebarMinimizer,
  CSidebarNavDropdown,
  CSidebarNavItem, 
} from '@coreui/react'
import '../scss/asc.css';
 
  
// sidebar nav config
import navigation from './_nav'

const TheSidebar = () => { 
  const show = useSelector(state => state.sidebarShow)
  //const smMat = localStorage.getItem('ApiM');
 
 // const [isMounted, setisMounted] = useState(true);
  const [item, setitem] = useState([]);

  //useEffect(() => {
      
//   const doSomething = async() =>{
//     ///api/misc/get_user_rights/1

//       var codee = localStorage.getItem("fk_user_tpye"); 
//     //console.log(codee);
//     var rows = []
//     var childrows = []
//     var schildrows = []
//    if (isMounted)
//      rows = item

//     var mstr = 1;
//     var fksmstr = 1;
//     var masterrr = {};
//     var index = 1;
//     var sindex = 1;
//     var smcouunt = 1;
//     var s_name = '';
//     var mname = '';
   
//    // async  fetchData =() => {
//       axios.get('/misc/get_user_rights/' + codee)
//     .then(res => {

//       const customers_infos = res.data;
//      console.log(customers_infos);
//     //  fetch('/api/misc/get_user_rights/' + codee)

//     //   .then((response) => response.json())
//     //   .then((customers_infos) => {

//         if (customers_infos!=null) {
//          // localStorage.setItem("my_rights", JSON.stringify(customers_infos))


//            customers_infos.map(result => {
 
//             if (index == 1) {
//               s_name = result.sub_master;
//               smcouunt = result.scounters;
//               childrows = [];
//             }


//             var s_master = [];

//             //console.log(result.scounters)
//             if (index != result.scounters) {

//               //  //console.log('idgr');
//               fksmstr = result.fk_sub_master;

//               {


//                 childrows.push({
//                   _tag: 'CSidebarNavItem',
//                   name: result.name,
//                   to: result.link,
//                   icon: <CIcon name="cil-speedometer" customClasses="c-sidebar-nav-icon" color="black" />

//                 });
//               }



//               index++;

//             } else {

//               index = 1;

//               //console.log(smcouunt);









//               if (smcouunt === 1) {
//                 childrows = [];
//                 childrows.push({
//                   _tag: 'CSidebarNavItem',
//                   name: result.name,
//                   to: result.link,
//                   icon: <CIcon name="cil-speedometer" customClasses="c-sidebar-nav-icon" color="black" />

//                 });
//                 //console.log('FFazzz' );
//                 rows.push({
//                   _tag: 'CSidebarNavDropdown',
//                   name: s_name,
//                   to: result.link,
//                   icon: <CIcon name="cil-speedometer" customClasses="c-sidebar-nav-icon" color="black" />,
//                   _children: childrows
//                 });

//               } else {

//                 //console.log('asd');
//                 childrows.push({
//                   _tag: 'CSidebarNavItem',
//                   name: result.name,
//                   to: result.link,
//                   icon: <CIcon name="cil-speedometer" customClasses="c-sidebar-nav-icon" color="black" />

//                 });
//                 rows.push({
//                   _tag: 'CSidebarNavDropdown',
//                   name: s_name,
//                   to: result.link,
//                   icon: <CIcon name="cil-speedometer" customClasses="c-sidebar-nav-icon" color="black" />,
//                   _children: childrows
//                 });

//               }


//               smcouunt = result.scounters;

//               //masterrr._children.concat({
//               //  _tag: 'CSidebarNavItem',
//               //  name: result.name,
//               //  to: result.link,
//               //  icon: <CIcon name="cil-speedometer" customClasses="c-sidebar-nav-icon" color="black" />

//               //});



//             }






//             //////// //console.log(result);




//           })
//         }
     
//         JSON.stringify(rows);
//         setitem(rows);
//         setitem(rows);
//         setitem(rows);
//         setitem(rows);
//         console.log(item);
//  //   console.log(JSON.stringify(rows));
//       });
   
  
//       if (isMounted)
//       {
    
     
 
//     }
//       // this.setState({ item: rows })
//   //  }


//     }


    useEffect(() => {
    
      vdata();
    },[item]);
    useEffect(() => {
     
   //   doSomething();
  }, []);


  const vdata =()=>{

if(item!=null)
{

return (
  <CSidebar 
  show={show}

 
>
  <CSidebarBrand  to="/Dashboard"  > <h1>E-POS</h1>
   
  </CSidebarBrand>

  <CSidebarNav    >

    <CCreateElement
      items={ navigation.filter(x=>x.fk_type==Number(localStorage.getItem("fk_user_type")))}
      components={{
        CSidebarNavDivider,
        CSidebarNavDropdown,
        CSidebarNavItem,
        CSidebarNavTitle
      }}
    />
  </CSidebarNav>
 <CSidebarMinimizer className="c-d-md-down-none"/>
</CSidebar>

);

}

  }
  return (
    vdata()
    // <CSidebar
    //   show={show}

    //   onShowChange={(val) => dispatch({ type: 'set', sidebarShow: val })}
    // >
    //   <CSidebarBrand style={{ backgroundColor: "#001221" }} className="d-md-down-none" to="/">
    //     <img src="../img/newlogo.png" className="rounded float-left" width='150' height='40' alt="No Logo" />
    //     <CLabel></CLabel>
    //   </CSidebarBrand>
    //   <CSidebarNav style={{ backgroundColor: "#002F59" }}>

    //     <CCreateElement
    //       items={navigation}
    //       components={{
    //         CSidebarNavDivider,
    //         CSidebarNavDropdown,
    //         CSidebarNavItem,
    //         CSidebarNavTitle

    //       }}
    //     />
    //   </CSidebarNav>
     
    // </CSidebar>
 
  )
}

export default React.memo(TheSidebar)
